import { configureStore } from '@reduxjs/toolkit';

import adminUiSlice from 'slice/admin-ui.slice';
import adminDataSlice from 'slice/admin-data.slice';

import appUiSlice from 'slice/app-ui.slice';
import appDataSlice from 'slice/app-data.slice';

const STORE = configureStore({
    reducer: {
        adminUI: adminUiSlice,
        adminData: adminDataSlice,

        appUI: appUiSlice,
        appData: appDataSlice,
    }
});
export default STORE;